import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { isEnum, isMultienum, isTextarea, isSingleLineText } from 'customer-data-objects/property/PropertyIdentifier';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import UITextInput from 'UIComponents/input/UITextInput';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import emptyFunction from 'react-utils/emptyFunction';

const PropertyInputReadOnly = props => {
  const {
    property,
    value
  } = props;
  const displayValue = getDisplayedValue(property, value);

  if (isTextarea(property) || isSingleLineText(property) || isEnum(property) && isMultienum(property)) {
    return /*#__PURE__*/_jsx(UIExpandableText, {
      hideButtonCaret: true,
      children: /*#__PURE__*/_jsx(UIExpandingTextArea, Object.assign({}, getTransferrableProps(props), {
        value: displayValue,
        onChange: emptyFunction,
        readOnly: true,
        shrink: true,
        children: displayValue
      }))
    });
  }

  return /*#__PURE__*/_jsx(UITextInput, Object.assign({}, getTransferrableProps(props), {
    value: displayValue,
    onChange: emptyFunction,
    readOnly: true
  }));
};

export default /*#__PURE__*/memo(PropertyInputReadOnly);